import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { CustomerTaxResidencyClient } from "../../../../../../Wrap/Api/Customer/CustomerTaxResidency";
import { DeathDetailClient } from "../../../../../../Wrap/Api/Customer/DeathDetail";
import { EmploymentDetailClient } from "../../../../../../Wrap/Api/Customer/EmploymentDetail";
import { PersonalDetailClient } from "../../../../../../Wrap/Api/Customer/PersonalDetail";
import { EmploymentDetail } from "../../../../../../Wrap/Models/Models/Customer/EmploymentDetail";
import { PersonalDetail } from "../../../../../../Wrap/Models/Models/Customer/PersonalDetail";
import { CustomerTaxResidencyModel } from "../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { ClientRecordTab } from "../Resource/Contents";
import { AccountRoleDispatcher, ClientRecordDispatcher, ClientRecordStore } from "../Store/Variable";
import { PensionProtectionClient } from "../../../../../../Wrap/Api/Customer/PensionProtection";
import { PensionProtectionDetails } from "../../../../../../Wrap/Models/Models/Customer/PensionProtection/PensionProtectionDetails";
import { CustomerPhoneNumbersClient } from "../../../../../../Wrap/Api/Customer/CustomerPhoneNumbers";
import { CustomerPhoneNumber } from "../../../../../../Wrap/Models/Models/Customer/CustomerPhoneNumber";
import { CustomerEmailAddressesClient } from "../../../../../../Wrap/Api/Customer/CustomerEmailAddresses";
import { CustomerEmailAddress } from "../../../../../../Wrap/Models/Models/Customer/CustomerEmailAddress";
import { ContactPreferenceDetailClient } from "../../../../../../Wrap/Api/Customer/ContactPreferenceDetail";
import { ContactPreferenceDetails } from "../../../../../../Wrap/Models/Models/Customer/ContactPreferenceDetails";
import { AddressDetailModel } from "../../../../../../Wrap/Models/Models/Customer/AddressDetailModel";
import { AddressDetailClient } from "../../../../../../Wrap/Api/Customer/AddressDetail";
import { ValidationStatus } from "../../../../../../Wrap/Core/Web/Validation/ValidationStatus";
import { ReportingTaxYearSettingModel } from "../../../../../../Wrap/Models/Models/Customer/Regulatory/ReportingTaxYearSettingModel";
import { ReportingTaxYearSettingClient } from "../../../../../../Wrap/Api/Customer/ReportingTaxYearSetting";
import { RegulatoryCheckDetailsModel } from "../../../../../../Wrap/Models/Models/Customer/RegulatoryCheckDetailsModel";
import { RegulatoryCheckDetailsClient } from "../../../../../../Wrap/Api/Customer/RegulatoryCheckDetails";
import { TaxFormModel } from "../../../../../../Wrap/Models/Models/Customer/Regulatory/TaxFormModel";
import { TaxFormClient } from "../../../../../../Wrap/Api/Customer/TaxForm";
import { NoteDetailModel } from "../../../../../../Wrap/Models/Models/Customer/NoteDetailModel";
import { NoteDetailClient } from "../../../../../../Wrap/Api/Customer/NoteDetail";
import { InstructionWorkInProgressClient } from "../../../../../../Wrap/Api/Instruction/InstructionWorkInProgress";
import { QuoteInstructionClient } from "../../../../../../Wrap/Api/Quote/QuoteInstruction";
import { QuoteToApplyInstructionClient } from "../../../../../../Wrap/Api/Apply/QuoteToApplyInstruction";
import { ApplyModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { Urls } from "../../../../Urls";
import { AccountRoleByActorClient } from "../../../../../../Wrap/Api/Account/AccountRoleByActor";
import { AccountRoleWithAccountDetails } from "../../../../../../Wrap/Models/Domains/Customers/AccountRoleWithAccountDetails";
import { AccountRoleDetailsClient } from "../../../../../../Wrap/Api/Customer/AccountRoleDetails";
import { OrganisationClient } from "../../../../../../Wrap/Api/Customer/Organisation";
import { Organisation } from "../../../../../../Wrap/Models/Models/Customer/Organisation";
import { Company } from "../../../../../../Wrap/Models/Models/Customer/Company";
import { VulnerabilityDetail } from "../../../../../../Wrap/Models/Models/Customer/VulnerabilityDetail";
import { VulnerabilityDetailClient } from "../../../../../../Wrap/Api/Customer/VulnerabilityDetail";
import { VulnerabilityCategory } from "../../../../../../Wrap/Constants/Enums/Customer/VulnerabilityCategory";
import { VulnerabilityType } from "../../../../../../Wrap/Constants/Enums/Customer/VulnerabilityType";
import { VulnerabilityOptions } from "../../../../../../Wrap/Models/Models/Customer/VulnerabilityOptions";
import { VulnerabilityOptionsClient } from "../../../../../../Wrap/Api/Customer/VulnerabilityOptions";
import { TrustDetailClient } from "../../../../../../Wrap/Api/Account/TrustDetail";
import { TrustDetail } from "../../../../../../Wrap/Models/Domains/Account/TrustDetail";
import { RelationshipType } from "../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { RelationshipClient } from "../../../../../../Wrap/Api/Customer/Relationship";
import { CompanyActorClient } from "../../../../../../Wrap/Api/Customer/CompanyActor";
import { RegulatoryCheckInfoType } from "../../../../../../Wrap/Constants/Enums/Customer/RegulatoryCheckInfoType";
import { AccountComplianceClient } from "../../../../../../Wrap/Api/Customer/AccountCompliance";
import { TrustMemberDeathDetailValidationClient } from "../../../../../../Wrap/Api/Customer/TrustMemberDeathDetailValidation";
import { ControllingPersonDetailsClient } from "../../../../../../Wrap/Api/Customer/ControllingPersonDetails";
import { ControllingPersonRoleDetailModel } from "../../../../../../Wrap/Models/Models/Customer/ControllingPersonRoleDetailModel";
import { PensionProtectionInstructionClient } from "../../../../../../Wrap/Api/Instruction/PensionProtectionInstruction";
import { CustomerPensionProtectionClient } from "../../../../../../Wrap/Api/Drawdown/CustomerPensionProtection";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { CustomerPensionProtectionModel } from "../../../../../../Wrap/Models/Domains/Drawdown/CustomerPensionProtectionModel";
import { AdditionalDataItemClient } from "../../../../../../Wrap/Api/Customer/AdditionalDataItem";
import { AdditionalDataItemType } from "../../../../../../Wrap/Constants/Enums/Domain/AdditionalDataItemType";
import { ActorOwnerClient } from "../../../../../../Wrap/Api/Customer/ActorOwner";

export class ClientRecordAction {
    public static getPersonalDetail(id: string) {
        const client = new PersonalDetailClient();
        const promise = client.get(Number(id));
        this.updateClientRecordStore(ClientRecordTab.PersonalDetail, promise);
    }

    public static putPersonalDetail(data: PersonalDetail, id: string) {
        const client = new PersonalDetailClient();
        const promise = client.put(Number(id), data);
        this.updateClientRecordStore(ClientRecordTab.PersonalDetail, promise);
    }

    public static getOrganisationDetail(id: string) {
        const client = new OrganisationClient();
        const promise = client.get(Number(id), "");
        this.updateClientRecordStore(ClientRecordTab.OrganisationDetails, promise);
    }

    public static putOrganisationDetail(data: Organisation, id: string) {
        const client = new OrganisationClient();
        const promise = client.put(data);
        this.updateClientRecordStore(ClientRecordTab.OrganisationDetails, promise);
    }

    public static getCompanyDetail(id: string, callback?) {
        const client = new CompanyActorClient();
        const promise = client.get(Number(id));
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
        if (!callback) {
            this.updateClientRecordStore(ClientRecordTab.CompanyDetails, promise);
        }
    }

    public static putCompanyDetail(data: Company, id: string) {
        const client = new CompanyActorClient();
        const promise = client.put(Number(id), data);
        this.updateClientRecordStore(ClientRecordTab.CompanyDetails, promise);
    }

    public static getAccountRoleDetail(customerId: string, callback?) {
        const client = new AccountRoleByActorClient();
        const promise = client.get(Number(customerId));
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
            let data = JSON.parse(JSON.stringify(result));
            if (!data) {
                data = [];
            }
            AccountRoleDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            AccountRoleDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getActorOwner(actorId: number, callback?) {
        const client = new ActorOwnerClient();
        const promise = client.get(actorId);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
    }

    public static getControllingPersonDetail(customerId: string, callback?) {
        const client = new ControllingPersonDetailsClient();
        const promise = client.get(Number(customerId));
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => { });
    }

    public static updateControllingPersonType(model: ControllingPersonRoleDetailModel, callback?) {
        const client = new ControllingPersonDetailsClient();
        const promise = client.put(model);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => { });
    }
    public static getPhoneNumberDetail(id: string) {
        const client = new CustomerPhoneNumbersClient();
        const promise = client.get(Number(id));
        this.updateClientRecordStore(ClientRecordTab.ContactDetail, promise);
    }

    public static putPhoneNumberDetail(data: CustomerPhoneNumber[], id: string) {
        const client = new CustomerPhoneNumbersClient();
        const promise = client.put(Number(id), data);
        this.updateClientRecordStore(ClientRecordTab.ContactDetail, promise);
    }

    public static getEmailDetail(id: string) {
        const client = new CustomerEmailAddressesClient();
        const promise = client.get(Number(id));
        this.updateClientRecordStore("EmailDetail", promise);
    }

    public static putEmailDetail(data: CustomerEmailAddress[], id: string) {
        const client = new CustomerEmailAddressesClient();
        const promise = client.put(Number(id), data);
        this.updateClientRecordStore("EmailDetail", promise);
    }

    public static getContactPerference(id: string) {
        const client = new ContactPreferenceDetailClient();
        const promise = client.get(Number(id));
        this.updateClientRecordStore("ContactPerference", promise);
    }

    public static putContactPerference(data: ContactPreferenceDetails, id: string) {
        const client = new ContactPreferenceDetailClient();
        const promise = client.put(Number(id), data);
        this.updateClientRecordStore("ContactPerference", promise);
    }

    public static getPensionProtection(customerId: number) {
        const client = new PensionProtectionClient();
        const promise = client.get(customerId);
        this.updateClientRecordStore(ClientRecordTab.PensionProtection, promise);
    }

    public static getCustomerPensionProtection(customerId: number) {
        const client = new CustomerPensionProtectionClient();
        const customerHierarchyId = HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId)
        const promise = client.get(customerHierarchyId);
        this.updateClientRecordStore(ClientRecordTab.PensionProtection, promise);
    }
    
    public static saveCustomerPensionProtection(
        customerId: number,
        pensionProtection: CustomerPensionProtectionModel,
        callback: (data) => void
    ) {
        const client = new CustomerPensionProtectionClient();
        const customerHierarchyId = HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId)
        const promise = client.put(customerHierarchyId, pensionProtection);
          promise.onSuccess((result) => {
              if (callback) callback(result);
        });
    }

    public static savePensionProtection(
        customerId: number,
        pensionProtection: PensionProtectionDetails,
        callback: (data) => void
    ) {
        const client = new PensionProtectionClient();
        const promise = client.post(customerId, pensionProtection);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
    }

    public static getPensionProtectionInstruction(hierarchyId: string) {
        const client = new PensionProtectionInstructionClient();
        const promise = client.get(hierarchyId);

        this.updateClientRecordStore(ClientRecordTab.PensionProtection, promise);
    }

    public static savePensionProtectionInstruction(
        hierarchyId: string,
        pensionProtection: PensionProtectionDetails,
        callback: (data) => void
    ) {
        const client = new PensionProtectionInstructionClient();
        const promise = client.put(hierarchyId, pensionProtection);
        promise.onSuccess((result) => {
            if (callback) callback(result);
        });
    }

    public static getInstructionWorkInProgress(page: number, pageSize: number, customerId: number) {
        const client = new InstructionWorkInProgressClient();
        const promise = client.get(page, pageSize, customerId);
        this.updateClientRecordStore("Activity", promise);
    }

    public static copyQuoteByid(id: number, customerId: number) {
        const client = new QuoteInstructionClient();
        const promise = client.get(id, null);
        promise.onSuccess((result) => {
            const quoteCopy = new QuoteToApplyInstructionClient();
            const copyPromise = quoteCopy.put(result);
            copyPromise
                .onSuccess((result: ApplyModel) => {
                    Navigator.navigateTo(Urls.get().NewBusinessWizard, {
                        scrollAfterNavigating: true,
                        queryParamsObject: {
                            customerid: customerId,
                            id: result.AccountRoleInstructionId,
                            quoteid: result.QuoteId,
                        },
                    });
                })
                .onError((error) => { });
        });
        promise.onError((err) => { });
    }

    public static getDeathDetail(id: string) {
        const client = new DeathDetailClient();
        const promise = client.get(Number(id));
        this.updateClientRecordStore("DeathDetail", promise);
    }

    public static putDeathDetail(data: EmploymentDetail, id: string, callBack?: (result) => void) {
        const client = new DeathDetailClient();
        const promise = client.put(Number(id), data);
        this.updateClientRecordStore("DeathDetail", promise);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }

    public static getTrustMemberDeathValidation(id: string, callBack: (result) => void) {
        const client = new TrustMemberDeathDetailValidationClient();
        const promise = client.get(Number(id));

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }

    public static getEmploymentDetail(id: string) {
        const client = new EmploymentDetailClient();
        const promise = client.get(Number(id));
        this.updateClientRecordStore("EmploymentDetail", promise);
    }

    public static getAccountRoleAndAccountDetails(customerId: string, callback) {
        const client = new AccountRoleDetailsClient();
        const promise = client.get(Number(customerId));
        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static putEmploymentDetail(data: EmploymentDetail, id: string) {
        const client = new EmploymentDetailClient();
        const promise = client.put(Number(id), data);
        this.updateClientRecordStore("EmploymentDetail", promise);
    }

    private static updateClientRecordStore(clientTab: ClientRecordTab | string, promise: any) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(ClientRecordStore.getData()));
            if (!data) {
                data = {};
            }
            data[clientTab] = result ? result : [];
            ClientRecordDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });

        promise.onError((err) => {
            ClientRecordDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getCutomerTaxResidency(
        customerId: number,
        callBack?: (val: Array<CustomerTaxResidencyModel>) => void
    ) {
        const client = new CustomerTaxResidencyClient();
        const promise = client.get(customerId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static removeRelationship(
        primaryId: number,
        secondaryId: number,
        relationship: RelationshipType[],
        callback
    ) {
        const client = new RelationshipClient();
        const promise = client.delete(primaryId, secondaryId, relationship);
        promise.onSuccess((d) => {
            callback(d);
        });
    }

    public static editRelationship(
        primaryId: number,
        secondaryId: number,
        originRelationship: RelationshipType[],
        newRelationship: RelationshipType[],
        callback
    ) {
        const client = new RelationshipClient();
        const promise = client.post(primaryId, secondaryId, originRelationship, newRelationship);
        promise.onSuccess((e) => {
            callback(e);
        });
    }

    public static saveCutomerTaxResidency(
        customerId: number,
        models: Array<CustomerTaxResidencyModel>,
        callBack?: (val: Array<ValidationStatus>) => void
    ) {
        const client = new CustomerTaxResidencyClient();
        const complianceClient = new AccountComplianceClient();
        const promise = client.put(customerId, models);

        promise.onSuccess((result) => {
            complianceClient.put(customerId).onSuccess(() => {
                if (callBack) {
                    callBack(result);
                }
            });
        });

        promise.onError((err) => { });
    }

    public static getVulnerabilityOptions(
        category: VulnerabilityCategory,
        type: VulnerabilityType,
        callBack?: (val: VulnerabilityOptions) => void
    ) {
        const client = new VulnerabilityOptionsClient();
        const promise = client.get(category, type);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
        promise.onError((err) => { });
    }

    public static getCustomerVulnerabilityDetails(
        customerId: number,
        callBack?: (val: Array<VulnerabilityDetail>) => void
    ) {
        const client = new VulnerabilityDetailClient();
        const promise = client.get(customerId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
        promise.onError((err) => { });
    }

    public static saveVulnerabilityDetail(
        customerId: number,
        VulnerabilityDetails: Array<VulnerabilityDetail>,
        callBack?: (val: any) => void
    ) {
        const client = new VulnerabilityDetailClient();
        const promise = client.put(customerId, VulnerabilityDetails);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }

    public static getTaxForm(customerId: number, callBack?: (val: TaxFormModel) => void) {
        const client = new TaxFormClient();
        const promise = client.get(customerId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static getHighValue(customerId: number, callback?) {
        const client = new AdditionalDataItemClient();
        const promise = client.get(customerId, AdditionalDataItemType.HighValueCustomer);

        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
    }

    public static putHighValue(customerId: number, highValueFlag: boolean, callback?) {
        const client = new AdditionalDataItemClient();
        let promise: any = null;
        if (highValueFlag) {
            promise = client.put(customerId, AdditionalDataItemType.HighValueCustomer, "true");
        } else {
            promise = client.delete(customerId, AdditionalDataItemType.HighValueCustomer);
        }
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
    }

    public static saveTaxForm(customerId: number, model: TaxFormModel, callBack?: (val: ValidationStatus) => void) {
        const client = new TaxFormClient();
        const promise = client.put(customerId, model);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static getReportingTaxYearSetting(
        customerId: number,
        callBack?: (val: Array<ReportingTaxYearSettingModel>) => void
    ) {
        const client = new ReportingTaxYearSettingClient();
        const promise = client.get(customerId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static saveReportingTaxYearSetting(
        customerId: number,
        model: Array<ReportingTaxYearSettingModel>,
        callBack?: (val: ValidationStatus) => void
    ) {
        const client = new ReportingTaxYearSettingClient();
        const promise = client.put(customerId, model);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static getCustomerAddress(customerId: number, callBack?: (val: Array<AddressDetailModel>) => void): void {
        const client = new AddressDetailClient();
        const promise = client.get(customerId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static saveCustomerAddress(
        customerId: number,
        addresses: Array<AddressDetailModel>,
        callBack?: (val: ValidationStatus) => void
    ): void {
        const client = new AddressDetailClient();
        const promise = client.put(customerId, addresses);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static addCustomerAddress(
        customerId: number,
        address: AddressDetailModel,
        callBack?: (val: ValidationStatus) => void
    ): void {
        const client = new AddressDetailClient();
        const promise = client.post(customerId, address);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static getCustomerRegulatoryCheckDetails(
        customerId: number,
        callBack?: (val: Array<RegulatoryCheckDetailsModel>) => void
    ): void {
        const client = new RegulatoryCheckDetailsClient();
        const promise = client.get(customerId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static saveCustomerRegulatoryCheckDetails(
        customerId: number,
        regChecks: Array<RegulatoryCheckDetailsModel>,
        editType: RegulatoryCheckInfoType,
        callBack?: (val: ValidationStatus) => void
    ): void {
        const client = new RegulatoryCheckDetailsClient();
        const promise = client.put(customerId, editType, regChecks);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static addCustomerRegulatoryCheckDetails(
        customerId: number,
        regCheck: RegulatoryCheckDetailsModel,
        editType: RegulatoryCheckInfoType,
        callBack?: (val: ValidationStatus) => void
    ): void {
        const client = new RegulatoryCheckDetailsClient();
        const promise = client.post(customerId, editType, regCheck);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static getCustomerNoteDetails(customerId: number, callBack?: (val: Array<NoteDetailModel>) => void): void {
        const client = new NoteDetailClient();
        const promise = client.get(customerId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static addCustomerNoteDetails(
        customerId: number,
        note: NoteDetailModel,
        callBack?: (val: ValidationStatus) => void
    ): void {
        const client = new NoteDetailClient();
        const promise = client.post(customerId, note);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static saveCustomerNoteDetails(
        customerId: number,
        note: NoteDetailModel,
        callBack?: (val: ValidationStatus) => void
    ): void {
        const client = new NoteDetailClient();
        const promise = client.put(customerId, note);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static deleteCustomerNoteDetails(
        customerId: number,
        note: NoteDetailModel,
        callback?: (val: ValidationStatus) => void
    ): void {
        const client = new NoteDetailClient();
        const promise = client.delete(customerId, note);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => { });
    }

    public static getAccountRoleWithAccountDetails(
        customerId: string,
        callBack?: (val: AccountRoleWithAccountDetails) => void
    ) {
        const client = new AccountRoleDetailsClient();
        const promise = client.get(Number(customerId));

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }

    public static getTrustDetails(hierarchyId: string, callBack?: (val: TrustDetail) => void) {
        const client = new TrustDetailClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => { });
    }
}
